"use client"

import { useEffect } from "react"
import { X, CheckCircle, AlertCircle, XCircle, Info } from "lucide-react"

const Toast = ({ toast, onClose }) => {
  useEffect(() => {
    if (toast.duration !== 0) {
      const timer = setTimeout(() => {
        onClose()
      }, toast.duration || 5000)

      return () => clearTimeout(timer)
    }
  }, [toast, onClose])

  const getIcon = () => {
    switch (toast.type) {
      case "success":
        return <CheckCircle className="w-5 h-5 text-green-600" />
      case "error":
        return <XCircle className="w-5 h-5 text-red-600" />
      case "warning":
        return <AlertCircle className="w-5 h-5 text-yellow-600" />
      default:
        return <Info className="w-5 h-5 text-[rgba(104,190,247,1)]" />
    }
  }

  const getBackgroundColor = () => {
    switch (toast.type) {
      case "success":
        return "bg-green-50 border-green-200"
      case "error":
        return "bg-red-50 border-red-200"
      case "warning":
        return "bg-yellow-50 border-yellow-200"
      default:
        return "bg-blue-50 border-blue-200"
    }
  }

  return (
    <div
      className={`fixed top-4 right-4 z-50 max-w-sm w-full ${getBackgroundColor()} border-2 rounded-2xl shadow-2xl p-4 transform transition-all duration-300 ease-in-out backdrop-blur-sm`}
    >
      <div className="flex items-start gap-3">
        {getIcon()}
        <div className="flex-1">
          <p className="text-sm font-bold text-gray-800">{toast.title}</p>
          {toast.message && <p className="text-sm text-gray-600 mt-1">{toast.message}</p>}
        </div>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors duration-200 p-1">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}

export default Toast
